<script setup lang="ts">
const props = defineProps<{
  data: SectionAboutRecord
  moduleIndex: number
}>()

const { level, isSemantic, invertedStyles } = useSectionRules(
  props.moduleIndex,
  props.data.invertColorTheme,
  !!props.data.title
)

onMounted(() => {
  useLenisSpeed()
})
</script>

<template>
  <div
    class="container grid-default overflow-hidden pb-15 pt-12 lg:pb-20 lg:pt-40"
    :class="invertedStyles"
  >
    <div class="col-span-12 lg:col-span-6 lg:flex lg:flex-col lg:justify-center xl:col-span-5">
      <div>
        <Heading
          v-if="data.title"
          class="mb-6 text-2xl font-medium lg:mb-20 lg:text-5xl-m"
          :level="level"
          :size="undefined"
          :is-semantic="isSemantic"
        >
          {{ data.title }}
        </Heading>
        <div v-if="data.html" class="editor mb-5 lg:text-lg" v-html="data.html" />
        <CallToAction
          v-if="Array.isArray(data.buttons) && data.buttons.length"
          class="ml-0 mt-8 lg:mt-12"
          :data="data.buttons"
        />
      </div>
    </div>
    <div class="col-span-12 lg:relative lg:col-span-6 xl:col-span-7">
      <Image
        v-if="data.media"
        :preload="moduleIndex === 0"
        loading="lazy"
        class="aspect-square w-full max-w-2xl md:absolute md:-bottom-48 md:-right-48 md:w-screen xl:max-w-4xl"
        sizes="(min-width: 1400px) 624px, (min-width: 780px) calc(43vw + 31px), (min-width: 700px) 624px, 93.68vw"
        :src="data.media?.responsiveImage ? data.media?.responsiveImage?.src : data.media?.url"
        :srcset="data.media?.responsiveImage ? data.media?.responsiveImage?.webpSrcSet : undefined"
        :width="
          data.media?.responsiveImage
            ? data.media?.responsiveImage?.width
            : (data.media?.width ?? 896)
        "
        :height="
          data.media?.responsiveImage
            ? data.media?.responsiveImage?.height
            : (data.media?.height ?? 896)
        "
        :alt="data.media?.alt ?? ''"
      />
    </div>
  </div>
</template>
